import { styled } from "styled-components";

export const Img = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
`;
